import React, { Component } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Subscribe from "../../../components/subscribe";
import BreadcrumbBar from "../../../components/breadcrumbBar";
import MQSGUtil from "../../../components/mqsgUtil";
import SwiperPagination from "../../../components/swiperpagination";
import AdvertBox from "../../../components/advert/advert";
import Select from "react-select";
import "./dailyhigh.css";
export default class DailyHighlights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlightdata: null,
      startDate: null,
      underlying: null
    };
    this.initRedirect(props, this.state);
  }

  initRedirect(props, state) {
    let underlying = null;
    const match = MQSGUtil.getData(props, "match", null);
    if (match !== null) {
      const params = MQSGUtil.getData(match, "params", null);
      if (params !== null) {
        underlying = MQSGUtil.getData(params, "underlying", null);
      }
    }
    state["underlying"] = underlying;
  }

  componentDidMount() {
    this.onFetchData();
  }

  onFetchStaticData() {
    const staticData = MQSGUtil.getStaticData("DailyHighlights");
    if (staticData !== null) {
      this.setState({ highlightdata: staticData });
    }
  }

  onFetchData(startDateString = null, underlying = null) {
    if (MQSGUtil.isUsingStaticData("DailyHighlights")) {
      setTimeout(() => {
        this.onFetchStaticData();
      }, 100); // pretend fetch
      return;
    }
    let highlightdata = null;
    let startdate = "";
    let underlyingString = "";
    if (startDateString !== null) {
      startdate = "&startdate=" + startDateString;
    }
    if (underlying !== null) {
      if (underlying.indexOf('&') !== -1) {
        underlying = underlying.replace('&', '%26')
      }
      underlyingString = "&underlying=" + underlying;
    } else if (this.state.underlying !== null){
      let urlUnderlying = this.state.underlying
      if (this.state.underlying.indexOf('&') !== -1) {
        urlUnderlying = this.state.underlying.replace('&', '%26')
      }
      underlyingString = "&underlying=" + urlUnderlying;
    }
    const url = MQSGUtil.getAPIBasePath() + "/NewsTableServlet?sp=todayhighlight&start=0" + startdate + underlyingString;
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          highlightdata = result;
          this.setState({ highlightdata });
        },
        (error) => {
          this.setState({ highlightdata });
        }
      );
  }

  onStartDateChange(startDate) {
    this.setState({ startDate });
    const startDateString = MQSGUtil.getDateString(startDate);
    this.onFetchData(startDateString);
  }

  render() {
    return (
      <div id="todayhighlight" className="pageobj">
        <BreadcrumbBar
          link="/home"
          group="Market news"
          title="Morning Market Buzz"
        />
        <div className="stripe-bg"></div>
        <div className="container-fluid">
          <div className="topimg hidden-sm hidden-xs">
            <img src="/img/bg/top-todayhighlight.jpg" alt="" />
          </div>
          <div className="row">
            <div className="col-md-8" style={{ paddingLeft: 0 }}>
              <NewsSection
                highlightdata={this.state.highlightdata}
                startDate={this.state.startDate}
                underlying={this.state.underlying}
                onStartDateChange={(startDate) =>
                  this.onStartDateChange(startDate)
                }
                getBuzzData={this.onFetchData.bind(this)}
              />
            </div>
            <div
              className="hidden-xs hidden-sm col-md-4"
              style={{ marginTop: "20px", paddingRight: 0 }}
            >
              <AdvertBox />
              <Subscribe />
              <Overnight />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class NewsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      underlyingList: [
      ],
    };
    this.rows = [];
    this.pageSize = 5;
    this.minDate = this.getDateByDays()
  }

  onDotClicked(pageIndex) {
    this.setState({ current: pageIndex });
  }

  onDateChange(date) {
    this.props.onStartDateChange(date);
  }
  setupRows(highlightdata) {
    const rows = [];
    const newslist = MQSGUtil.getData(highlightdata, "newsList");
    if (newslist !== null && Array.isArray(newslist)) {
      newslist.forEach((news, index) => {
        const date = MQSGUtil.getData(news, "date");
        const title = { __html: MQSGUtil.getData(news, "en_title") };
        const short = { __html: MQSGUtil.getData(news, "en_short") };
        const id = MQSGUtil.getData(news, "id");
        const column1 = (
          <div className="newstbl-col-left">
            <span className="newstbl-col-date">{date}</span>
          </div>
        );
        const column2 = (
          <div className="newstbl-col-right">
            <h3 className="newstbl-col-dt" dangerouslySetInnerHTML={title}></h3>
            <div
              className="newstbl-col-dd"
              dangerouslySetInnerHTML={short}
              style={{ overflowWrap: "break-word", overflowX: 'auto' }}
            ></div>
            <div className="newstbl-col-rm">
              <Link
                to={"/marketnews/highlight/todayhighlight/" + id}
                className="btn btn-primary btn-default"
                target="_blank"
              >
                Read more
              </Link>
            </div>
          </div>
        );
        const row = (
          <div className="newstbl-row rowtmpl" key={"daily_" + id}>
            {column1}
            {column2}
          </div>
        );
        rows.push(row);
      });
    }
    this.rows = rows;
    return rows;
  }

  getRows() {
    // page index 0: current -> pageSize * (current + 1) - 1
    // page index 1: pageSize * current -> pageSize * 2 - 1
    const pageIndex = this.state.current;
    const startRowIndex = this.pageSize * pageIndex;
    const endRowIndex = this.pageSize * (pageIndex + 1);
    if (this.rows.length > endRowIndex) {
      return this.rows.slice(startRowIndex, endRowIndex);
    }
    return this.rows.slice(startRowIndex);
  }
  componentDidMount() {
    this.getUnderlyingList()
  }
  getUnderlyingList() {
    const url =
      MQSGUtil.getAPIBasePath() +
      "/NewsTableServlet?sp=underlying"
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          var Result = result.map((item, i) => {
            item.label = MQSGUtil.getUnderlyingTickerDisplayName(item.underlying_ric, item.label);
          })
          result.unshift(
            { value: "", label: "All underlying" },
            { value: "index", label: "ALL INDICES" },
            { value: "hkstocks", label: "All HK stocks" },
            { value: "sgstocks", label: "All SG Stocks" },
          )
          this.setState({ underlyingList: result });
        },
        (error) => {
          this.setState({ underlyingList: result });
        }
      );
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.highlightdata !== this.props.highlightdata) {
      this.setupRows(nextProps.highlightdata);
    }
    return true;
  }
  getbgDate(date) {
    var m = new Date().getMonth() + 1;
    var M = new Date(date).getMonth() + 1;
    var cls = m != M ? "random " : undefined;
    return cls
  }
  onChange(selected) {
    this.props.getBuzzData(null, selected.value)
  }
  getDateByDays() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var nowData = year + "-" + month + "-" + '01';
    return new Date(nowData);
  }
  handleSelect(e, q) {
    return false
  }
  render() {
    const rows = this.getRows();
    return (
      <div
        id="newssection"
        style={{ position: "relative" }}
        className="section"
      >
        <div className="page-header">
          <h2>Morning Market Buzz</h2>
          <div className="searchbox searchbox-toppage input-group" style={{ width: '35%' }}>
            <div id="powersearch">
              <Select
                className="center"
                placeholder="Select underlying"
                options={this.state.underlyingList}
                onChange={this.onChange.bind(this)}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "center",
                    ':hover': {
                      backgroundColor: '#1A73E8',
                    }
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    justifyContent: 'center'
                  })
                }}
              />
            </div>
          </div>
        </div>
        <p className="section-p">
          Keep up to date with the latest news relating to warrant underlyings!
        </p>
        <div id="commentarytbl" className="newstbl">
          <div className="newstbl-htxt">Latest News</div>
          <div className="newstbl-content">{rows}</div>
          <div className="newstbl-bttm">
            <div id="datepicker" className="newstbl-cal-icon input-group date">
              <input type="hidden" readOnly className="form-control" />
              <div className="input-group-addon">
                <DatePicker
                  selected={this.props.startDate}
                  onChange={(date) => this.onDateChange(date)}
                  maxDate={new Date()}
                  value=""
                  // dayClassName={(date) =>
                  //   this.getbgDate(date)
                  // }
                  // minDate={this.minDate}
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </div>
            </div>
            <SwiperPagination
              current={this.state.current}
              rows={this.rows}
              pageSize={this.pageSize}
              onDotClicked={(pageIndex) => this.onDotClicked(pageIndex)}
            />
          </div>
          <hr className="hr-hmgbm" />
        </div>
      </div>
    );
  }
}

class Overnight extends Component {
  render() {
    return (
      <div className="section qlink-section">
        <div className="page-header">
          <h2 className="small">Overnight market wrap</h2>
        </div>
        <p>
          Hear about the latest news in Global markets that might affect your
          trading day.
        </p>
        <div className="section-qlink-img section-qlink-marketwrap">
          <a
            href="/marketnews/overnightmarkets"
            className="section-qlink-achor"
          >
            <img src="/img/bullet/qlink-achor.png" alt="" />
          </a>
        </div>
      </div>
    );
  }
}
